import React, { PropsWithChildren } from 'react'
import { ListItemText } from '@mui/material'

const DecoratedText = ({ children, underline }: PropsWithChildren<{ underline?: boolean }>) => {
  return (
    <ListItemText
      primaryTypographyProps={{
        sx: {
          textDecorationLine: underline ? 'underline' : 'none',
          textDecorationThickness: '1px',
          textUnderlineOffset: '2px',
        },
      }}
    >
      {children}
    </ListItemText>
  )
}

export const FulfilmentFAQsText = () => {
  return <DecoratedText>Fulfilment FAQs</DecoratedText>
}

export const TermsAndConditionsText = ({ underline = true }: { underline?: boolean }) => {
  return <DecoratedText underline={underline}>Terms & Conditions</DecoratedText>
}
